// extracted by mini-css-extract-plugin
export var background = "_70-0";
export var buttonPrimary = "_70-1";
export var container = "_70-2";
export var containerTopLayerApi = "_70-3";
export var feature = "_70-6";
export var featureBody = "_70-7";
export var featureIcon = "_70-8";
export var featureSummary = "_70-a";
export var featureTitle = "_70-9";
export var modal = "_70-g";
export var modalAction = "_70-f";
export var modalCloseButton = "_70-e";
export var modalFeatures = "_70-5";
export var modalFooter = "_70-b";
export var modalImageLogo = "_70-c";
export var modalLogo = "_70-d";
export var redoModal = "_70-4";